import dynamic from 'next/dynamic';
import Link from 'next/link';

import { SustainabilityReportsBlockFragment } from '@hultafors/hultaforsgroup/types';

import styles from './sustainability-reports-block.module.scss';

const HTag = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.HTag),
);

const Paragraph = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.Paragraph),
);

interface SustainabilityReportsBlockProps
  extends SustainabilityReportsBlockFragment {
  priority?: boolean;
}

export const SustainabilityReportsBlock: React.FC<
  SustainabilityReportsBlockProps
> = ({ priority, reports, title }) => {
  if (!reports.length) return null;

  const reportsMapper = (
    report: SustainabilityReportsBlockFragment['reports'][number],
    index: number,
  ) => {
    const year = report.title?.match(/\d{4}/);
    const title = report.title?.replace(/\d{4}/, '');

    if (!report.url) return;

    return (
      <Link
        className={styles['report-link']}
        href={report?.url}
        key={`Report-${index}`}
        rel="noreferrer"
        target="_blank"
      >
        <HTag
          adjustStyles={{ color: 'var(--color-white)', textAlign: 'center' }}
          className={styles['report-year']}
          styleType="h3"
          type="p"
        >
          {year}
        </HTag>
        <Paragraph
          adjustStyles={{ color: 'var(--color-white)', textAlign: 'center' }}
          styleType="sub-heading"
        >
          {title || 'Report'}
        </Paragraph>
      </Link>
    );
  };

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <HTag
          adjustStyles={{ color: 'var(--color-white)' }}
          className={styles['title']}
          styleType="h2"
          type={priority ? 'h1' : 'h2'}
        >
          {title}
        </HTag>
        <div className={styles['reports']}>{reports?.map(reportsMapper)}</div>
      </div>
    </div>
  );
};
